export default "__VITE_ASSET__BRFtg2jP__"